import { Component, HostBinding, OnInit, Optional } from '@angular/core';
import { WorkforceAppComponent } from 'src/app/workforce/app.wf.component';
import { Router, Event, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-downloads',
    templateUrl: './downloads.component.html',
    styleUrls: ['./downloads.component.scss'],
    standalone: false
})
export class DownloadsComponent implements OnInit {
  // The Workforce shell provides no content padding; pad ourselves when
  // rendered inside it (the GLD shell pads its content container).
  @HostBinding('class') get hostPadding(): string {
    return this.wfParent ? 'tw-box-border tw-block tw-p-4 md:tw-p-8' : '';
  }

  constructor(
    private router: Router,
    @Optional() public wfParent: WorkforceAppComponent | null
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        // Type guard to confirm the event type
        if (event instanceof NavigationEnd) {
          const url = event.url;
          const orgId = this.extractOrgId(url);

          // If we're at the base downloads URL, redirect to the downloads-list tab
          if (url.endsWith('/downloads')) {
            this.router.navigate([`/${orgId}/downloads/downloads-list`]);
          }
        }
      });
  }

  private extractOrgId(url: string): string {
    // Extract the organization ID from the URL
    // URL format is expected to be /:orgId/downloads/...
    const parts = url.split('/');
    return parts[1]; // The orgId should be the first part after the leading slash
  }
}
